import React, { useState, useEffect } from 'react';
import api from '../services/api';

const CACHE_KEY = 'mp_lead_cache';
const CACHE_TTL = 30 * 24 * 60 * 60 * 1000;

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.name || !data.phone) return null;
    if (Date.now() - (data.savedAt || 0) > CACHE_TTL) {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export default function LeadForm({ person, searchTerm, onSuccess }) {
  const [cached] = useState(readCache);
  const [auto, setAuto] = useState(!!cached);
  const [name, setName] = useState(cached ? cached.name : '');
  const [phone, setPhone] = useState(cached ? cached.phone : '');
  const [consent, setConsent] = useState(cached ? cached.consent === true : false);
  const [loading, setLoading] = useState(!!cached);
  const [error, setError] = useState('');

  const send = async (leadName, leadPhone, leadConsent) => {
    setLoading(true);
    setError('');
    try {
      const { data } = await api.post('/leads', {
        name: leadName,
        phone: leadPhone,
        searchTerm,
        deceasedId: person.id,
        graveId: person.grave_id,
        consent: leadConsent,
      });
      onSuccess(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao enviar. Tente novamente.');
      setLoading(false);
      setAuto(false);
    }
  };

  useEffect(() => {
    if (cached) {
      send(cached.name, cached.phone, cached.consent === true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!name.trim() || !phone.trim()) {
      setError('Preencha todos os campos');
      return;
    }
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        name: name.trim(),
        phone: phone.trim(),
        consent: !!consent,
        savedAt: Date.now(),
      })
    );
    await send(name.trim(), phone.trim(), consent);
  };

  const useOtherContact = () => {
    localStorage.removeItem(CACHE_KEY);
    setAuto(false);
    setName('');
    setPhone('');
    setConsent(false);
    setError('');
  };

  if (auto && loading) {
    return (
      <div className="form-card">
        <h2>Localização encontrada</h2>
        <p>
          Olá, <strong>{cached.name}</strong>. Estamos usando os dados da sua última
          consulta para liberar a localização automaticamente...
        </p>
        <div className="btn-spinner" />
        <button
          type="button"
          className="btn-secondary"
          style={{ width: '100%', marginTop: 8 }}
          onClick={useOtherContact}
        >
          USAR OUTRO CONTATO
        </button>
        <div className="form-security">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
          Seus dados estão seguros conosco.
        </div>
      </div>
    );
  }

  return (
    <form className="form-card" onSubmit={handleSubmit}>
      <h2>Localização encontrada</h2>
      <p>Para visualizar a localização do jazigo, informe seus dados:</p>

      {cached && (
        <div className="saved-contact-note">
          Dados salvos da última consulta — altere ou{' '}
          <button type="button" onClick={useOtherContact}>usar outro contato</button>.
        </div>
      )}

      {error && <div className="toast error" style={{ position: 'static', marginBottom: 16 }}>{error}</div>}

      <div className="form-group">
        <label className="form-label">Seu nome completo</label>
        <input
          type="text"
          className="form-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Digite seu nome"
        />
      </div>

      <div className="form-group">
        <label className="form-label">WhatsApp / Telefone</label>
        <input
          type="tel"
          className="form-input"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="(67) 99999-0000"
        />
      </div>

      <div className="checkbox-group">
        <input
          type="checkbox"
          id="consent"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
        />
        <label htmlFor="consent">
          Autorizo o contato da empresa para informações relacionadas aos serviços do cemitério.
        </label>
      </div>

      <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
        {loading ? 'ENVIANDO...' : 'VER LOCALIZAÇÃO'}
      </button>

      <div className="form-security">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        Seus dados estão seguros conosco.
      </div>
    </form>
  );
}
